<template>
  <div class="list_index">
      <el-button v-if="type == 'sds1'" type="primary" class="yl-button" @click="checkout2">SDS1</el-button>
      <el-button v-else type="primary" class="yl-button" @click="checkout1">SDS2</el-button>
      <el-table stripe border :data="tableData" v-if="type == 'sds1'">
          <el-table-column label="DateTime" prop="ts"></el-table-column>
          <el-table-column label="PartID" prop="sds1processpartid"></el-table-column>
          <el-table-column label="BeadSize" prop="sds1processbeadsize"></el-table-column>
          <el-table-column label="DispensePressre" prop="sds1dispensepressre"></el-table-column>
          <el-table-column label="SetpointVolume" prop="uc1sds1setpointvolume"></el-table-column>
          <el-table-column label="ActualVolume" prop="uc1sds1actualvolume"></el-table-column>
          <el-table-column label="PartTime" prop="uc1sds1parttime"></el-table-column>
          <el-table-column label="FaultCode" prop="sds1faultcode"></el-table-column>
      </el-table>
      <el-table stripe border :data="tableData" v-else>
          <el-table-column label="DateTime" prop="ts"></el-table-column>
          <el-table-column label="PartID" prop="sds2processpartid"></el-table-column>
          <el-table-column label="BeadSize" prop="sds2processbeadsize"></el-table-column>
          <el-table-column label="DispensePressre" prop="sds2dispensepressre"></el-table-column>
          <el-table-column label="SetpointVolume" prop="uc1sds2setpointvolume"></el-table-column>
          <el-table-column label="ActualVolume" prop="uc1sds2actualvolume"></el-table-column>
          <el-table-column label="PartTime" prop="uc1sds2parttime"></el-table-column>
          <el-table-column label="FaultCode" prop="sds2faultcode"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
        background
        layout="total, prev,next"
        :current-page="page"
        :page-size="size"
        :total="count"
        @current-change="changePage"
        ></el-pagination>
    </div>
  </div>
</template>

<script>
import DeviceTemplateService from '@/api/deviceTemplate';
export default {
    data(){
        return{
           type:'sds1',
           tableData:[],
           serialNumber:'',
           timer:'',
           page:1,
           size:10,
           count:0,
           remove:0,
           status:1,
           getRemove:0
        }
    },
    methods:{
        checkout2(){
            this.type = 'sds2';
            this.page = 1;
            this.remove = 0;
            this.getRemove = 0;
            this.getTableData()
        },
        checkout1(){
            this.type = 'sds1';
            this.page = 1;
            this.remove = 0;
            this.getRemove = 0;
            this.getTableData()
        },
        getTableData(){
            if(this.status == 1){
                this.remove += this.getRemove;
            }else if(this.status == 0){
                this.remove -= this.getRemove;
            }else{
                this.remove = 0
            }
            DeviceTemplateService.getTableData({
                page:this.page,
                size:this.size,
                serialNumber:'GL5022132004661',
                model:this.type,
                remove:this.remove
            }).then(res=>{
                if(res.data && res.data != null){
                    this.tableData = res.data.projectSiteList;
                    this.count = res.data.count;
                    this.getRemove = res.data.remove
                }
            }).catch(err=>{
                this.$message.error(err.message)
            })
        },
        changePage(page){
            if(page == 1){
                this.remove = 0;
                this.getRemove = 0;
            }
            if(page > this.page || page == 1){
                this.status = 1;
            }else if(page < this.page && page != 1){
                this.status = 0;
            }else{
                this.status = 2;
            }
            this.page = page;
            this.getTableData()
        }
    },
    created(){
      if(this.$route.query.serial_number){
        // this.serialNumber = this.$route.query.serial_number;
      }
    },
    mounted(){
        this.getTableData()
        // let _this = this;
        // this.timer = setInterval(()=>{
        //     _this.getTableData()
        // },10000)
    },
    beforeDestroy(){
        clearInterval(this.timer)
    }
}
</script>

<style scoped>
.list_index{
   height: 100vh;
   background: url('https://yliiotcloud.obs.cn-east-3.myhuaweicloud.com/22631653358657_.pic_hd.jpg') no-repeat;
   background-size:100% 100% ;
}
</style>